import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import Heading from '../text/Heading';

const LoadingWrapper = styled.div`
  .fa-spin {
    -webkit-animation: fa-spin 0.8s infinite linear;
    animation: fa-spin 0.8s infinite linear;
  }
  .loading {
    padding-top: ${getTheme('spacer', 'l')};
    padding-bottom: ${getTheme('spacer', 'l')};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &__icon {
      font-size: ${getTheme('fontSize', 'jumbo')};
      color: ${getTheme('black', '_800')};
    }
    &__heading {
      margin-top: ${getTheme('marginBottom', 'l')};
      font-weight: 300;
      color: ${getTheme('textColor', 'altLight')};
    }
    &__text {
      font-size: ${getTheme('fontSize', 'note')};
      font-weight: 600;
      margin-bottom: 0;
    }
  }
`;

class Loading extends Component {
  render() {
    return (
      <LoadingWrapper>
        <div className="loading">
          <FontAwesomeIcon
            className="fa-spin loading__icon"
            icon={faCircleNotch}
            aria-label="Loading…"
          />
          {this.props.heading && (
            <Heading level="heading2">
              <h3 className="loading__heading">{this.props.heading}</h3>
            </Heading>
          )}
          {this.props.text && <p className="loading__text">{this.props.text}</p>}
        </div>
      </LoadingWrapper>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js